<template>
  <div class="pay-completion">
    <div class="container">
      <div class="pay">
        <div class="state-box">
          <img src="~assets/img/order/icon_done_right.png" class="icon" />
          <p class="pay-title">
            {{ $t.orderDetail.paySuccess }}
          </p>
        </div>
        <div class="actions">
          <div class="btn" v-if="isLogging" @click="actionDetail">
            {{ $t.orderDetail.viewDetail }}
          </div>
          <div class="btn" @click="backHome">{{ $t.orderDetail.backHome }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import { isProduction } from "@environment/type";
import { mapGetters } from "vuex";

export default {
  name: "payCompletion",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      isProduction: isProduction(),
    };
  },
  computed: {
    ...mapGetters(["isLogging"]),
    queryParams() {
      return this.$route.query;
    },
    wbNumber() {
      return this.queryParams.wbNumber;
    },
  },
  mounted() {
    if (this.isProduction && !this.isApp && this.platform == "ios") {
      window.location.href = "vtrackClient://";
    }
  },
  methods: {
    actionDetail() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerReplace, {
        isParams: true,
        path: "paybillList",
        name: "paybillList",
        query: [
          {
            name: "wbNumber",
            value: this.wbNumber,
          },
        ],
      });
    },
    backHome() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: this.isLogging ? "home" : "auth/login",
        query: [],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~assets/scss/var";
.pay-completion {
  .container {
    min-height: 120vh;
    background: -webkit-gradient(
      linear,
      left top,
      right bottom,
      color-stop(0%, #2750aa),
      color-stop(100%, #132660)
    );
    .pay {
      padding: 100px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &.error {
        .actions {
          margin-top: 15px;
        }
      }

      .state-box {
        display: flex;
        align-items: center;

        .icon {
          width: 24px;
          height: 24px;
        }

        .pay-title {
          margin: 0 0 0 10px;
          color: white;
          font-size: 20px;
          font-weight: bold;
        }
      }

      .actions {
        display: flex;
        margin-top: 30px;

        .btn {
          height: 30px;
          width: 110px;
          border-radius: 15px;
          border: 1px solid white;
          color: #fffeee;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;

          & + .btn {
            margin-left: 12px;
          }
        }
      }
    }
  }
}
</style>
